import React from 'react';
import {FeatureBoundary} from '../../contexts/FeatureBoundary';
import {GlobalPermissionEnum} from '../../schema-types/globalTypes';
import {Panel} from '../../components/Panel/Panel';
import {themeColors} from '../../theme/Theme';
import useTitle from '../../hooks/useTitle';
import {useAccountContext} from '../../contexts/AccountContext';
import {NewBankAccountForm} from './NewBankAccountForm';
import {validateBankAccountForm} from './bankAccountValidators';
import {bankAccountFields} from './bankAccountFields';

export const NewBankAccountPage: React.FC = () => {
  const {account} = useAccountContext();
  useTitle(`New bank account - ${account?.name}`);
  return (
    <FeatureBoundary
      features={[GlobalPermissionEnum.can_access_bank_accounts]}
      showErrorIfDenied
    >
      <Panel color={themeColors.lightGreen} title="New bank account">
        <NewBankAccountForm
          formFields={bankAccountFields}
          validate={validateBankAccountForm}
        />
      </Panel>
    </FeatureBoundary>
  );
};
